/**
 * Contact-list request logic (pure, no React) — unit-tested without rendering the hook.
 */
import { Qualifications } from '../../campaign-builder.types';

const ALL_QUALIFICATION_OPTIONS: Qualifications[] = [Qualifications.A, Qualifications.B, Qualifications.C, Qualifications.NOT_JUDGED];

/**
 * Maps the "Bewertung" multi-select to the `aiJudgement` query param the API expects
 * (comma-separated grades, `not-judged` for unrated contacts).
 * Returns `undefined` (= no filter) when the select is empty or every option is picked,
 * so the default state keeps showing every contact, including judging errors.
 */
export const buildAiJudgementParam = (activeQualifications: Qualifications[], hasJudgingSettings: boolean): string | undefined => {
  if (!hasJudgingSettings || activeQualifications.length === 0) return undefined;
  if (ALL_QUALIFICATION_OPTIONS.every((option) => activeQualifications.includes(option))) return undefined;
  return activeQualifications.join(',');
};
